module.exports = __webpack_public_path__ + "img/bell-02.20aa5e89.svg";